import {
  fetchOffersFromOrderIfNeeded,
  fetchRecurringOffersFromOrder,
} from 'actions/entities/recipients/fetchOffers';
import {
  fetchOffersFromOrderIfNeededForIndia,
  fetchRecurringOffersFromOrderForIndia,
} from 'actions/entities/recipients/india/fetchOffers';
import { PaymentOptions } from 'components/PaymentOptions/PaymentOptions';
import { NoOptions } from '../../PaymentOptions/components/RecurringPayment/NoOptions/NoOptions';
import { NoOptionsIndia } from '../../PaymentOptions/components/SinglePaymentOptions/components/NoOptions/NoOptionsIndia';

const PaymentOptionsStep = ({
  isWizardIndia = false,
}: { isWizardIndia?: boolean }) => {
  const fetchOffers = isWizardIndia
    ? fetchOffersFromOrderIfNeededForIndia
    : fetchOffersFromOrderIfNeeded;

  const fetchRecurringOffers = isWizardIndia
    ? fetchRecurringOffersFromOrderForIndia
    : fetchRecurringOffersFromOrder;

  const noOptionsComponent = isWizardIndia ? NoOptionsIndia : NoOptions;

  return (
    <PaymentOptions
      fetchOffers={fetchOffers}
      fetchRecurringOffers={fetchRecurringOffers}
      noOptionsComponent={noOptionsComponent}
    />
  );
};

export type FetchRecurringOffers = typeof fetchRecurringOffersFromOrder;

export { PaymentOptionsStep };
